import compassPlusLogo from '../../images/compass_plus/logos/compass-plus-logo.svg';
import {Amplify} from 'aws-amplify';
import awsExports from '../../aws-exports';
import {HELP_CENTRE_SUPPORT_REQUEST_URL} from '../../constants';


const Header = () => {
  Amplify.configure(awsExports);
  const dashboardUrl = process.env.REACT_APP_COMPASS_PLUS_URL;

  return (
    <header className="login-header">
      <div className="container">
        <img src={compassPlusLogo} width="300" alt="Compass Plus"/>
        <div className="header-nav">
          <ul className="m-0 p-0">
            <li>
              <a
                href={HELP_CENTRE_SUPPORT_REQUEST_URL}
                className="cec-btn cec-btn-primary-teal link-as-button">
                Contact us
              </a>
            </li>
            <li className="ms-2">
              <a
                href={dashboardUrl + "/register"}
                className="cec-btn cec-btn-primary-teal link-as-button">
                Create an Account
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
